import {useNavigate} from "react-router-dom";
import {MouseEvent} from "react";
import {IconButton} from "@mui/material";
import {ArrowBackIosNewRounded} from "@mui/icons-material";

export function BackButton({backPath}: { backPath?: string }) {
    const navigate = useNavigate();

    const handleBack = (event: MouseEvent<HTMLButtonElement>) => {
        if (backPath) {
            navigate(backPath);
        } else {
            navigate(-1)
        }
    };

    return (
        <IconButton
            onClick={handleBack}
            aria-controls="back">
            <ArrowBackIosNewRounded style={{
                color: "#1B4A95",
                backgroundColor: "#F5F5FA",
                borderRadius: "30%",
                width: "1.5em",
                height: "1.5em",
                padding: 8
            }}/>
        </IconButton>
    );
}